export default [
  {
    path: '/cafe24/intro',
    name: 'cafe24_intro',
    meta: {
      title: '카페24',
      requiresAuth: false
    },
    component: () => import(/* webpackChunkName: "Cafe24ComponentIntro" */ '@/components/menus/cafe24/component/intro'), // 카페24 URL 리턴 페이지
    props: (route) => ({
      // lang: route.query.lang,
      mall_id: route.query.mall_id,
      // nation: route.query.nation,
      shop_no: route.query.shop_no,
      // timestamp: route.query.timestamp,
      user_id: route.query.user_id,
      user_name: route.query.user_name
      // user_type: route.query.user_type
      // hmac: route.query.hmac
    })
  },
  {
    path: '/cafe24/redirect',
    name: 'cafe24_redirect',
    meta: {
      title: '카페24 가입 문의',
      requiresAuth: false
    },
    component: () => import(/* webpackChunkName: "Cafe24ComponentRedirect" */ '@/components/menus/cafe24/component/redirect'), // 카페24 가입 문의 페이지
    props: (route) => ({
      code: route.query.code,
      state: route.query.state
    })
  }
];



// WEBPACK FOOTER //
// ./src/router/subRoutes/cafe24.js